import { ProctoringSessionSummary } from "@verity/api-client/types";
import { AiSummary, LiveProctorSummary } from "../Summary";

type SummaryPanelProps = {
	isLiveSessionProctor?: boolean;
	sessionSummary?: ProctoringSessionSummary;
	onClose: () => void;
	getDefaultSummary: () => Promise<string>;
	onSave: (summary: string) => Promise<void>;
};

export default function SummaryPanel({
	isLiveSessionProctor,
	sessionSummary,
	onClose,
	getDefaultSummary,
	onSave,
}: SummaryPanelProps) {
	if (isLiveSessionProctor || sessionSummary?.source === "liveProctor") {
		return (
			<LiveProctorSummary
				data={sessionSummary}
				onClose={onClose}
				getDefaultSummary={getDefaultSummary}
				onSave={onSave}
			/>
		);
	}

	return <AiSummary onClose={onClose} data={sessionSummary} />;
}
